module.exports = __webpack_public_path__ + "img/water-droplet-2.d2c6a16b.png";